import { Activity } from '@ofqual/portal-activity-feed';

import {
 ApplicationStatus,
 ExpertsApplyModel,
} from '../domain/ExpertsApplyFormModel';
import { fieldLabels } from '../presentation/Sections/fieldLabels';

export interface ChangeApplicationStatusModel {
 status?: ApplicationStatus;
 feedbackToCitizen?: string;
}

export type ExpertsApplyModelDialogProps = {
 item: ExpertsApplyModel;
 onClose: () => void;
};

export enum DialogType {
 ChangeApplicationStatus,
 ActivityAction,
 SendPublicMessage,
 AddCaseNote,
 AddInternalMessage,
 SpecialistSmsChange,
 LcmChanged,
 AddExpertiseActivity,
 AddExpertiseForm
}
export type FieldChange = {
 field: keyof typeof fieldLabels;
 oldValue: string | null;
 newValue: string | null;
};
export type ChangeActivityBody = {
 changes: FieldChange[];
};
export interface EntityDialog {
 // focusedActivity: Activity;
 dialogType: DialogType;
 focusedActivity?: Activity;
}
export type ActivityDialogProps = {
 activity: Activity;
 onClose: () => void;
};
